import React, { useState } from "react";
import { Image, Button } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import { Toggle } from "../../../../superAdminComponents/superAdminReusable/reusableSuperAdminButton/Toggle";

export const EventsTableBody = (props) => {
  const [data, setData] = useState(props.data);

  const [TrDetail, setTrDetail] = useState({ TrDetail: false });
  const showTr = () => setTrDetail({ TrDetail: !TrDetail.TrDetail });

  return (
    <React.Fragment>
      <tbody className="w-100 super-admin-all-vendor-main-table-body">
        <tr className="w-100 p-0">
          <td className="p-0 w-100">
            <table className="w-100">
              <tbody className="sd_body_css">
                <tr className="sd_body_table-row" onClick={showTr}>
                  <td style={{ width: "20%", fontWeight: "bold" }}>
                    {/* <img
                      src={require("../../../../../assets/images/superadmin/ordericon/takeaway.svg")}
                      width="35px"
                    /> */}
                    {data.name}
                    <br />

                    <span
                      className={`badge badge-${
                        data.onstate ? `success` : `warning`
                      }`}
                    >
                      {data.onstate ? "Online" : "Offline"}
                    </span>
                  </td>
                  <td style={{ width: "15%" }}>
                    <div className="justify-content-center">
                      {data.start_date} <br /> to <br />
                      <span style={{ color: "#EE3A23" }}>{data.end_date}</span>
                    </div>
                  </td>
                  <td style={{ width: "8%", fontWeight: "bold" }}>
                    {data.viewed} / {data.used}
                  </td>
                  <td style={{ width: "10%", fontWeight: "bold" }}>
                    {data.live}
                  </td>
                  <td style={{ width: "8%" }}>{data.pending_req}</td>
                  <td style={{ width: "8%" }}>{data.tickets_booked}</td>
                  <td style={{ width: "4%" }}>{data.rsvp}</td>
                  <td
                    style={{ width: "6%" }}
                    onClick={(e) => {
                      if (!e) var e = window.event;
                      e.cancelBubble = true;
                      if (e.stopPropagation) e.stopPropagation();
                    }}
                  >
                    <Toggle
                      checked={data.primary}
                      // toggleFunction={toggleFunction}
                    />
                  </td>

                  <td
                    style={{ width: "6%" }}
                    onClick={(e) => {
                      if (!e) var e = window.event;
                      e.cancelBubble = true;
                      if (e.stopPropagation) e.stopPropagation();
                    }}
                  >
                    <Toggle
                      checked={data.status}
                      // toggleFunction={toggleFunction}
                    />
                  </td>
                  <td style={{ width: "15%" }}>
                    <NavLink to="/superadmin-offline-events-details" className="enViewDashboard">
                      <Image
                        src={require("../../../../../assets/images/ActionImages/image/onboarding.svg")}
                        alt="View"
                        title="View"
                        fluid
                        className="mr-2"
                      />
                      <div className="f12-500">View Dashboard</div>
                    </NavLink>
                  </td>
                </tr>
                {TrDetail.TrDetail && (
                  <tr className="sd_accordion_body">
                    <div className="container-fluid">
                      <div className="row">
                        <div
                          className="col-2"
                          style={{ borderRight: "1px solid #E0E0E0" }}
                        >
                          <h5 style={{ color: "#EE3A23" }}>More actions</h5>
                          <br />
                          <br />
                          <div className="more-actions-orders-desc d-flex align-items-center justify-content-end mb-2">
                            <Button
                              variant="link"
                              className="enIconBtn mr-3 action_icon_padding"
                            >
                              <Image
                                src={require("../../../../../assets/images/superadmin/ordericon/view.svg")}
                                alt="View"
                                title="View"
                                fluid
                              />
                            </Button>{" "}
                            <Button
                              variant="link"
                              className="enIconBtn mr-3 action_icon_padding"
                            >
                              <Image
                                src={require("../../../../../assets/images/superadmin/ordericon/view.svg")}
                                alt="View"
                                title="View"
                                fluid
                              />
                            </Button>{" "}
                            <Button
                              variant="link"
                              className="enIconBtn mr-3 action_icon_padding"
                            >
                              <Image
                                src={require("../../../../../assets/images/superadmin/ordericon/Edit.svg")}
                                alt="Edit"
                                title="Edit"
                                fluid
                              />
                            </Button>
                          </div>
                        </div>
                        <div className="col-2">
                          <h5>Venue</h5>
                          <br />
                          <p>Royal Palms Pune</p>
                        </div>
                        <div className="col-3">
                          <h5>Hyperlink</h5>
                          <br />
                          <p>Https://youtube/mCE2tqOfsDI</p>
                        </div>
                        <div className="col-2">
                          <h5>Event Code</h5>
                          <br />
                          <p>XXX</p>
                        </div>
                        <div className="col-3">
                          <h5>Coupon code</h5>
                          <br />
                          <p>NS2198</p>
                        </div>
                      </div>
                    </div>
                  </tr>
                )}
              </tbody>
            </table>
          </td>
        </tr>
      </tbody>
    </React.Fragment>
  );
};
